module.exports = __webpack_public_path__ + "img/logonegativo.24aff92e.png";